import { createContext, useCallback, useState } from 'react';
import { set, lensPath, pathOr, findIndex, propEq, omit } from 'ramda';
import { setupNamespacePipelines } from './dashboardTabUtils';

export interface ApplicationViewPrefsContextProps {
  currentViewPrefs: CurrentViewPrefs;
  setCurrentTabIndex: (_tabId: string) => void;
  setCurrentTabPref: (state: any) => void;
}

interface CurrentViewPrefs {
  currentTab: number;
  currentTabs: any;
}
const currentTab = 0;
const currentTabs = setupNamespacePipelines();

const defaultContext = {
  currentViewPrefs: {
    currentTab,
    currentTabs,
  },
  setCurrentTabIndex: (_tabId: any) => null,
  setCurrentTabPref: (_currentTabs: any) => null,
};
export const applicationViewPrefsContext =
  createContext<ApplicationViewPrefsContextProps>(defaultContext);
export const useApplicationViewPrefs = (): ApplicationViewPrefsContextProps => {
  const [currentViewPrefs, setCurrentViewPrefs] = useState(
    defaultContext.currentViewPrefs
  );

  const setCurrentTabIndex = useCallback(
    (_tabId: any) => setCurrentViewPrefs(set(lensPath(['currentTab']), _tabId)),
    []
  );
  const setCurrentTabPref = useCallback(
    (_currentTabs: any) =>
      setCurrentViewPrefs(set(lensPath(['currentTabs']), _currentTabs)),
    []
  );
  return {
    currentViewPrefs,
    setCurrentTabIndex,
    setCurrentTabPref,
  };
};
/* update the default context tab array without delete old values
 * tabsState {array} total array of tab
 * updateThisTabKeys {string} which key to be updated in the array
 * updateThisTabValue{any} what value should be updated
 */
const updateTabViewPrefAtIndex = (
  tabState: any,
  updateThisTabKeys: any,
  updateThisTabValue: any
) => {
  return { ...omit(updateThisTabKeys, tabState), ...updateThisTabValue };
};
/* update the default context tab array values
 * _tabNumber {String} which means which tab to update(active tab)
 * tabsState {array} total array of tab
 * updateThisTabKey {string} which key to be updated in the array
 * updateThisTabValue{any} what value should be updated
 */
export const updateTabViewPrefsAtIndex = (
  _tabNumber: any,
  tabsState: any,
  updateThisTabKey: any,
  updateThisTabValue: any,
  tabState?: any
) => {
  const index = findIndex(propEq('tabNumber', Number(_tabNumber)))(tabsState);
  const _tabState = tabState ? tabState : pathOr('', [index], tabsState);

  return set(
    lensPath([index]),
    updateTabViewPrefAtIndex(_tabState, updateThisTabKey, updateThisTabValue)
  )(tabsState);
};
/* get the context tab array values
 * key {num} wich key we want to get from context tab array
 * tabsState {array} total array of tab
 */
export const getCurrentTabState = (
  currentTabNum: any,
  key: string,
  tabsState: any
) => {
  const index = findIndex(propEq(key, currentTabNum))(tabsState);
  return pathOr('', [index], tabsState);
};
